import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-employee-detail',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatDividerModule, MatProgressSpinnerModule],
  templateUrl: './employee-detail.component.html',
  styleUrl: './employee-detail.component.scss'
})
export class EmployeeDetailComponent implements OnInit, OnDestroy {
  loading = true;
  error: string | null = null;
  profile: any = null;
  photoUrl: string | null = null;
  timeline: any[] = [];
  timelineLoading = false;

  constructor(
    private api: ApiService,
    public dialogRef: MatDialogRef<EmployeeDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string | number }
  ) {}

  ngOnInit(): void {
    this.api.getEmployeeById(this.data.id).subscribe({
      next: (res) => {
        this.profile = res?.data ?? res;
        if (this.profile?.hasProfilePicture) {
          this.api.getEmployeePhotoBlob(this.profile.id).subscribe({
            next: (blob) => { this.photoUrl = URL.createObjectURL(blob); },
            error: () => { this.photoUrl = null; }
          });
        }
        this.loading = false;
        this.loadTimeline();
      },
      error: (err) => {
        this.error = err?.message || 'Failed to load employee profile.';
        this.loading = false;
      }
    });
  }

  loadTimeline(): void {
    if (!this.profile?.id) return;
    this.timelineLoading = true;
    this.api.getEmployeeTimeline(this.profile.id).subscribe({
      next: (res) => {
        this.timeline = res?.data ?? res ?? [];
        this.timelineLoading = false;
      },
      error: () => {
        this.timeline = [];
        this.timelineLoading = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
  }

  close(): void {
    this.dialogRef.close();
  }
}
